export default "https://cdn-static.gokick.com/assets/09fae944e838c54f14fd77486c4f90b3472cb396/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";